// @ts-nocheck
import { populate } from 'populate';
import type { Container, Sprite } from 'pixi.js';

const raw = {
  list: [
    {
      id: 'a8f2d76d-edc2-440c-8854-88a555760dd6',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: ''
    },
    {
      id: '59e576e2-f18c-4b17-b2b3-d6056f94ee5e',
      type: 'Sprite',
      name: 'pigNormal',
      className: '',
      x: -21,
      y: 28,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Piggy_Bank_Main_Menu_Icon_Normal',
      parent: 'a8f2d76d-edc2-440c-8854-88a555760dd6',
      stateByName: {
        claimable: {
          visible: false
        },
        inClaimAnimation: {
          visible: false
        },
        Silver: {
          texture: 'Piggy_Bank_Main_Menu_Icon_Normal_Silver'
        },
        Gold: {
          texture: 'Piggy_Bank_Main_Menu_Icon_Normal_Gold'
        },
        Opal: {
          texture: 'Piggy_Bank_Main_Menu_Icon_Normal_Opal'
        },
        Diamond: {
          texture: 'Piggy_Bank_Main_Menu_Icon_Normal_Diamond'
        },
        Normal: {
          texture: 'Piggy_Bank_Main_Menu_Icon_Normal'
        },
        Legacy: {
          texture: 'Piggy_Bank_Main_Menu_Icon_Normal'
        }
      }
    },
    {
      id: 'f73cd376-7fd6-486e-a2cb-e6008f05fe40',
      type: 'Sprite',
      name: 'pigHappy',
      className: '',
      x: -21,
      y: 28,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Piggy_Bank_Main_Menu_Icon_Happy',
      parent: 'a8f2d76d-edc2-440c-8854-88a555760dd6',
      stateByName: {
        claimable: {
          visible: false
        },
        inClaimAnimation: {
          visible: false
        },
        Silver: {
          texture: 'Piggy_Bank_Main_Menu_Icon_Happy_Silver'
        },
        Gold: {
          texture: 'Piggy_Bank_Main_Menu_Icon_Happy_Gold'
        },
        Opal: {
          texture: 'Piggy_Bank_Main_Menu_Icon_Happy_Opal'
        },
        Diamond: {
          texture: 'Piggy_Bank_Main_Menu_Icon_Happy_Diamond'
        },
        Normal: {
          texture: 'Piggy_Bank_Main_Menu_Icon_Happy'
        },
        Legacy: {
          texture: 'Piggy_Bank_Main_Menu_Icon_Happy'
        }
      }
    },
    {
      id: 'f18c6881-310c-4451-bdc6-f160a0abb583',
      type: 'Sprite',
      name: 'pigSorry',
      className: '',
      x: -21,
      y: 28,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Piggy_Bank_Main_Menu_Icon_Sorry',
      parent: 'a8f2d76d-edc2-440c-8854-88a555760dd6',
      stateByName: {
        claimable: {
          visible: false
        },
        inClaimAnimation: {
          visible: false
        },
        Silver: {
          texture: 'Piggy_Bank_Main_Menu_Icon_Sorry_Silver'
        },
        Gold: {
          texture: 'Piggy_Bank_Main_Menu_Icon_Sorry_Gold'
        },
        Opal: {
          texture: 'Piggy_Bank_Main_Menu_Icon_Sorry_Opal'
        },
        Diamond: {
          texture: 'Piggy_Bank_Main_Menu_Icon_Sorry_Diamond'
        },
        Normal: {
          texture: 'Piggy_Bank_Main_Menu_Icon_Sorry'
        },
        Legacy: {
          texture: 'Piggy_Bank_Main_Menu_Icon_Sorry'
        }
      }
    }
  ],
  x: 0,
  y: 0,
  width: 760,
  height: 760,
  version: '3.1.0',
  stateNames: [
    'Silver',
    'Gold',
    'Opal',
    'Diamond',
    'Normal',
    'Legacy'
  ],
  handleResize: false
} as const;

export class PiggyBankSmallLayout {
  static raw = raw;
  root!: Container;
  pigNormal!: Sprite;
  pigHappy!: Sprite;
  pigSorry!: Sprite;
  StateName!: 'Silver' | 'Gold' | 'Opal' | 'Diamond' | 'Normal' | 'Legacy';

  constructor() {
    populate(this, raw);
  }
}
